import _ from 'lodash';

const searchResultsCreator = () => {
	const results = [
		'baseData-permanentAddress',
		'baseData-mailingAddress',
		'baseData-beneficiaryData-1',
		'baseData-beneficiaryData-2',
		'baseData-beneficiaryData-3',
		'baseData-beneficiaryData-4',
		'baseData-beneficiaryData-5',
		'insuredData-permanentAddress',
		'insuredData-mailingAddress',
		'financingData-creditorDetails',
		'propertyDetails',
	];

	let groups = [];

	_.each(results, result => {
		groups[result] = {
			postal_code: [],
			city: [],
			address_name: [],
			address: [],
		};
	});

	return groups;
};

export default function state() {
	return {
		loading: false,
		mobile_menu: false,
		category: null,
		popup: null,
		popupHasClose: true,
		currentStep: 0,
		baseData: {
			insurance_events: {
				basic: [],
				extend: [],
			},
			searchResult: {
				...searchResultsCreator(),
			},
			premise_types: [],
			movable_types: {
				movables: [],
				valuables: [],
			},
			outbuildingTypes: [],
			outbuildingLocations: [],
		},
		real_estate: {
			id: null,
			user_id: null,
			postal_code: null,
			city: null,
			address: null,
			house_number: null,
			parcel_number: null,
			house_number_to: null,
			building: null,
			stairway: null,
			floor: null,
			door: null,
			type: null,
			ownership: null,
			floor_area: null,
			insurance_value: null,
			movable_value: null,
			valuable_value: null,
			year: null,
			inhabitants: null,
			wall_type: null,
			roof_type: null,
			is_public_space: null,
			is_permanently_inhabited: null,
			mortgage: null,
			under_construction: null,
		},
		calculation: {
			id: null,
			user_id: null,
			consultant_id: null,
			real_estate_id: null,
			payment_method: null,
			payment_frequency: null,
			contract_method: 0,
			start_of_risk: null,
			birth_date: null,
			is_online_communication: null,
			is_online_claims_settlement: null,
			hash: null,
			email: null,
			phone: null,
		},
		questionAnswers: {
			isNewContract: null,
			isMfo: null,
			startOfRisk: null,
            bondNumber: null,
			insurer: null,
			twoYear: null,
            oldContractLastStep: false,
            hasCondominiumInsurance: null,
            condominiumInsurer: null,
		},
		temp: {
			insurance_events: [],
			property_details: null,
		},
		insurance_events: [],
		premises: [],
		outbuildings: [],
		buildings: [],
		movables: [],
		valuables: [],
		offers: null,
		selectedOffers: [],
		real_estates: [],
		selectedUser: null,
		inactive_events: [],
		wsErrors: [],
		insuranceValueIsRandom: false,
		hasParcelNumber: false,
		onMyOwn: false,
		error: false,
		makeNotify: false,
        is_business_process: false,
        bikaRealEstate: [],
        loadedAddress: null,
        loadingBikaId: null,
        otherConsultantName: null,
        bikaImportInvalidEmail: null,
        matchingRealEstateUsers: [],
        is_campaign_calculation: false,
	};
}
